<template>
    <div>
        <span v-for='(item, index) of detail.toService' :key='item.id'>
            {{item.title}}
            {{detail.toService.length-1 === index? '':", "}}
        </span>
    </div>
</template>

<script>
export default {
    props: {
        detail: Object
    }
}
</script>

<style lang="scss" scoped>
    .el-form-item {
        img {
            vertical-align: middle;
            margin-left: 5px;
        }
    }
</style>
